import React from 'react';
import Icon from '../AppIcon';

const ErrorDisplay = ({ message, onRetry }) => (
  <div className="flex flex-col items-center justify-center p-4 bg-red-50 border border-red-200 rounded-md">
    <Icon name="AlertTriangle" className="h-8 w-8 text-red-500 mb-2" />
    <p className="text-red-700 font-semibold">Something went wrong</p>
    <p className="text-red-600 text-sm mb-4">{message || 'An unexpected error occurred.'}</p>
    {onRetry && (
      <button
        onClick={onRetry}
        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
      >
        Try Again
      </button>
    )}
  </div>
);

export default ErrorDisplay;